const textStyles = {
    homeHeading: {
        fontSize: ["38px", "52px"],
        fontFamily: "canada-type-gibson, Arial",
        fontWeight: 600,
        marginY: "30px",
        color: "color1",
    },
    // override Chakra's default styles
    "4xl": {
        value: {
            letterSpacing: 0,
        },
    },
    "5xl": {
        value: {
            letterSpacing: 0,
        },
    },
    "6xl": {
        value: {
            letterSpacing: 0,
        },
    },
    "7xl": {
        value: {
            letterSpacing: 0,
        },
    },
}

export default textStyles
